import { Api } from '../api';
import { AuthUtils } from '@shared/utils';
import { auth } from '../endpoints';
import type {
  ChangePasswordRequest,
  ChangePasswordResponse,
  ConfirmLoginRequest,
  ConfirmLoginResponse,
  RecoveryConfirmationRequest,
  RecoveryRequest,
  RecoveryResponse,
  ResendCodeResponse,
  StartLoginRequest,
  StartLoginResponse,
} from './models';

export class AuthApi extends Api {
  static startLogin = (request: StartLoginRequest) => this.post<StartLoginRequest, StartLoginResponse>({ url: auth.startLogin(), data: request });

  static confirmLogin = (request: ConfirmLoginRequest) => {
    const tempToken = AuthUtils.getTempToken();
    return this.post<ConfirmLoginRequest, ConfirmLoginResponse>({
      url: auth.confirmLogin(),
      data: request,
      headers: { Authorization: `Bearer ${tempToken}` },
    });
  };

  static loginResendCode = () => {
    const tempToken = AuthUtils.getTempToken();
    return this.post<undefined, ResendCodeResponse>({ url: auth.loginResendSms(), headers: { Authorization: `Bearer ${tempToken}` } });
  };

  static logout = () => this.post<undefined, undefined>({ url: auth.logout(), responseType: 'none' });

  static recovery = (request: RecoveryRequest) => this.post<RecoveryRequest, RecoveryResponse>({ url: auth.recovery(), data: request });

  static recoveryConfirmation = (request: RecoveryConfirmationRequest) => {
    const recoveryTempToken = AuthUtils.getRecoveryTempToken();
    return this.post<RecoveryConfirmationRequest, undefined>({
      url: auth.recoveryConfirmation(),
      headers: { Authorization: `Bearer ${recoveryTempToken}` },
      data: request,
      responseType: 'none',
    });
  };

  static changePassword = (request: ChangePasswordRequest) =>
    this.post<ChangePasswordRequest, ChangePasswordResponse>({ url: auth.changePassword(), data: request });
}
